var map = {
	"./ATM.png": 845,
	"./BNB.png": 846,
	"./CAC.png": 847,
	"./CACII.png": 848,
	"./CADS.png": 849,
	"./CADSII.png": 850,
	"./CardCancellation.png": 484,
	"./ETH.png": 851,
	"./FAITD.png": 852,
	"./FIL.png": 853,
	"./GAAITD.jpg": 854,
	"./KIAITD.jpg": 855,
	"./MANA.png": 856,
	"./MANEKI.png": 857,
	"./OXG.png": 858,
	"./OXX.png": 859,
	"./SAITD.png": 860,
	"./SHBI.png": 861,
	"./TAITD.png": 862,
	"./WINAITD.jpg": 863,
	"./WYOHO.png": 864,
	"./YOHO.png": 865,
	"./YYOHO.png": 866,
	"./ada.png": 867,
	"./arrow-down-blue.svg": 868,
	"./arrow-down-grey.svg": 869,
	"./arrow-right-white.png": 870,
	"./arrow-right.svg": 871,
	"./banner.png": 485,
	"./big_unicorn.png": 290,
	"./blue-loader.svg": 161,
	"./bmt.jpg": 872,
	"./bridge.png": 360,
	"./bridge1.png": 482,
	"./btc.png": 873,
	"./cad.jpg": 874,
	"./capital.svg": 479,
	"./capital1.svg": 478,
	"./cardCollectionAgentBg.png": 486,
	"./cardCollectionAgentGrayBg.png": 487,
	"./circle-grey.svg": 875,
	"./circle.svg": 876,
	"./coinbaseWalletIcon.svg": 294,
	"./cret.png": 877,
	"./dropdown-blue.svg": 878,
	"./dropdown.svg": 879,
	"./dropup-blue.svg": 880,
	"./dydx.png": 881,
	"./emptyNew.png": 191,
	"./ethereum-logo.png": 882,
	"./fortmaticIcon.png": 295,
	"./giftCard.png": 488,
	"./gtc.png": 883,
	"./inch.png": 884,
	"./invitation.svg": 885,
	"./invitation1.svg": 886,
	"./invitePng.png": 489,
	"./link.svg": 887,
	"./magnifying-glass.svg": 888,
	"./mask.png": 889,
	"./matic.png": 890,
	"./menu.svg": 891,
	"./metamask.png": 483,
	"./noise.png": 292,
	"./plus-blue.svg": 892,
	"./plus-grey.svg": 893,
	"./pool.svg": 481,
	"./pool1.svg": 480,
	"./poolNew.png": 490,
	"./portisIcon.png": 296,
	"./question-mark.svg": 894,
	"./question.svg": 895,
	"./sand.png": 896,
	"./share.png": 897,
	"./spinner.svg": 898,
	"./swap.svg": 477,
	"./swap1.svg": 476,
	"./tip.png": 491,
	"./token-list-logo.png": 899,
	"./token-list/lists-dark.png": 900,
	"./token-list/lists-light.png": 901,
	"./token-logo.png": 190,
	"./tokenlistsgrouped.png": 902,
	"./tp.svg": 903,
	"./trustWallet.png": 904,
	"./uni.png": 905,
	"./usdt.png": 906,
	"./walletConnectIcon.svg": 297,
	"./wdqb_btc.svg": 907,
	"./write-offSuc.png": 492,
	"./x.svg": 908,
	"./xl_uni.png": 291
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 556;